export default "__VITE_ASSET__o39Y1gTF__"